import React, { useEffect, useState } from "react";
import { Button, Card, DatePicker, Form, notification, Popconfirm, Skeleton, Spin, Table } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useStoreUpdaterWithAPI } from "../../../../Hooks/UseStoreUpdaterWithApi";
import {  ManualEntryGrid, MeterConfigGrid, ProuctionExcelConfigGrid, UserConfigGrid } from "../../../../Common/UIConstants";
import { useSelector } from "react-redux";
import {  CONFIGURATION_EXCEL } from "../../../../Common/Constants";
import { APIConstants } from "../../../../Common/APIConstants";
import ExcelPopup from "../../../CommonScreens/CreateExcel";
// import UserPopup from "../../../CommonScreens/CreateUser";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const ManualEntry = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { loading, makeRequest } = useStoreUpdaterWithAPI();
    const [selectedSiteID, setSelectedSiteID] = useState(null);
    const[refetch, setRefetch] =useState(false);
    const [rowData, setRowData] = useState([])
      const [isUpdate, setIsUpdate] = useState(false);
     const [selectedRow, setSelectedRow] = useState(null);
    const [isAdd, setIsAdd] = useState(false);
    const [dates, setDates] = useState(null);

    const mode = useSelector((state) => state.darkMode);
  
    const { isdarkMode } = mode;
  
    const [form] = Form.useForm();
  
    useEffect(() => {
    
    }, []);
  
    // useEffect(() => {
    //   if (location.pathname === `${CONFIGURATION_EXCEL}/new-user-add-popup`) {
    //     setIsAdd(true);
       
    //   }else {
    //     setIsAdd(false);
      
    //   }
    // }, [location.pathname]);
  
console.log(isdarkMode) 
    const handleDateChange = (value) => {
      if (value) {
        const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
        const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");
  
        setDates([fromDate, toDate]); 
      } else {
        setDates(null);
      }
    };
  
    const handleNotification = (msg) => {
      notification.open({
        message: `${msg}`,
      });
    };
  
    const handleAddPopup = () => {
      navigate(`${CONFIGURATION_EXCEL}/excel-add-popup`);
    };
  
  
    const handleDeleteSubmit = (groupID) => { 
      console.log(groupID)
      const body = {
        createdOn: groupID?.createdon,
      };
      try {
        makeRequest({
          type: APIConstants.POST,
          url: `${APIConstants.DELETE_IGARASHI_PRODUCTION_DATA}`,
          body: body,
        });
  
        // const updatedFlowGroupList = flowGroupList.filter(
        //   (item) => item.groupID !== groupID
        // );
        // setFlowGroupList(updatedFlowGroupList);
        setRefetch(!refetch);
        handleNotification("Successfully Deleted");
        form.resetFields();
      } catch (err) {
        console.log(err);
      }
    };

      const getResponse = () => {
        console.log(dates)
        // setIsLoading(true);
        makeRequest({
          type: APIConstants.GET,
          url: `${APIConstants.IGARASHI_PRODUCTION_DATA}?FromDate=${dates ? dates[0] : ""}&ToDate=${dates ? dates[1] : ""}`,
        }).then((res) => {
          // setIsLoading(false);
          console.log(res)
          if (Array.isArray(res)) {
            const updatedData = res.map((item) => ({
              ...item,
              actions: {
                update: handleUpdatePopup,
                confirmDelete: handleDeleteSubmit,
              },
            }));
            setRowData(updatedData);
            // onClose();
          } else {
            console.error('Expected array but got:', res);
          }
        }).catch((err) => {
          // setIsLoading(false);
          console.error('API request failed', err);
        });
      };
        const handleUpdatePopup = (rowData) => {
          console.log("Selected Row Data:", rowData);
          setIsAdd(false)
          setIsUpdate(true)
          setSelectedRow(rowData)  // Log the row data
          navigate(`${CONFIGURATION_EXCEL}/manual-entry-add-popup`);
        
        };
    
      useEffect(() => {
        getResponse();
        if (selectedSiteID=='null') {
        }
      }, [selectedSiteID,refetch,dates]);
      const rangePresets = [
        { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
        { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
        { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
        { label: 'Last 90 Days', value: [dayjs().add(-90, 'd'), dayjs()] },
      ];
        
        useEffect(() => {
          console.log("Selected Row in Modal:", selectedRow); 
          if (isAdd && !selectedRow) {
            form.resetFields(); 
          } else if (isUpdate && selectedRow) {
            form.setFieldsValue(selectedRow); 
          }
        }, [isAdd, isUpdate, selectedRow, form]);
      console.log(rowData)
      console.log(isAdd)
      console.log(dates)
      
      // const groupByDateOnly = (data) => {
      //   const grouped = {};
      
      //   data.forEach(({ createdon, meterID, productionValue }) => {
      //     const dateOnly = createdon.split('T')[0]; // Extract just the date
      
      //     if (!grouped[dateOnly]) {
      //       grouped[dateOnly] = {
      //         key: dateOnly,
      //         createdon: dateOnly,
      //         children: [],
      //       };
      //     }
      
      //     grouped[dateOnly].children.push({
      //       key: `${dateOnly}`,
      //       meterID,
      //       productionValue,
      //     });
      //   });
      
      //   return Object.values(grouped); // This will return ONE parent row per unique date
      // };
      
      const groupDataByDate = (data) => {
        const grouped = {};
      
        data.forEach((item) => {
          const date = item.createdon.split("T")[0];
      
          if (!grouped[date]) {
            grouped[date] = {
              key: date,             // unique key per date
              createdon: date,
              actions: 'Edit',
              child: [],
            };
          }
      
          grouped[date].child.push({
            // key: `${date}-${item.meterID}`,
            meterID: item.meterID,
            productionValue: item.productionValue,
          });
        });
      
        return Object.values(grouped); // one parent per unique date
      };
      
        const groupedData = groupDataByDate(rowData);
        console.log(groupedData)
      
        const parentColumns = [
          {
            title: 'Created On',
            dataIndex: 'createdon',
            key: 'createdon',
          },
          {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (_, record) => (
              <div className="space-x-2">
                <Popconfirm
                  title="Are you sure to delete this Converter"
                  icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                  onConfirm={() => handleDeleteSubmit(record)}
                  trigger="click"
                >
                  <Button className="text-red-500" type="text" icon={<DeleteOutlined />} />
                </Popconfirm>
              </div>
            ),
          },
        ];
        const childColumns = [
          {
            title: 'Meter ID',
            dataIndex: 'meterID',
            key: 'meterID',
          },
          {
            title: 'Production Value',
            dataIndex: 'productionValue',
            key: 'productionValue',
          },
        ];
        
   
        console.log(parentColumns)
        console.log(groupedData)  
    return (
      <div>
        <Card className={`w-full h-auto dark ${isdarkMode ? 'darkmode border-0' : 'whitemode'} `}>
          <div className="flex justify-between items-center w-full mb-2 ">
          <div  className="flex items-center justify-between shadow-2xl border rounded-xl p-2">
      <h3 className={`${isdarkMode? "text-white":"text-black"}  mt-1`}>Select Date Range:</h3> 
      <RangePicker 
          presets={rangePresets}
          // showTime={{ format: "HH:mm" }} // Enables time selection
          format="YYYY-MM-DD"
          onChange={handleDateChange}
          className={`${!isdarkMode? "customRangePicker-light":"customRangePicker-dark "}    w-[300px] ml-2  border border-white `} 
        />
    </div>

            <Button onClick={handleAddPopup} className="mb-2">
              Add Excel
            </Button>
          </div>
  
          <ExcelPopup
             isAdd={isAdd}
             setIsAdd={setIsAdd}
             isUpdate={isUpdate}
             setIsUpdate={setIsUpdate}
             setRefetch={setRefetch}
             refetch={refetch}
             title={selectedRow ? "Edit Excel" : "Add New Excel "}
             selectedRow={selectedRow}
          />
          
          <div className="overflow-auto">
            <Spin indicator={<Spin size="large" />} spinning={loading}>
              {/* <ProuctionExcelConfigGrid
              data={rowData}
                handleDeleteSubmit={handleDeleteSubmit}
              /> */}
            <Table
      columns={parentColumns}
      dataSource={groupedData}
      expandable={{
        expandedRowRender: (record) => (
          <Table
            columns={childColumns}
            dataSource={record.child}
            pagination={false}
            rowKey="key"
          />
        ),
      }}
      pagination={false}
      rowHoverable={false}
      className={`${isdarkMode ? "dark-table" : "white-table "}`}
      rowKey="key"
    />
            </Spin>
          </div>
        </Card>
      </div>
    );
};

export default ManualEntry;
